import XYZColor from '../classes/xyz-color';

const lab2xyz = ({ lightness, a, b, alpha }) => {
  let x;
  let y;
  let z;

  y = (lightness + 16) / 116;
  x = a / 500 + y;
  z = y - b / 200;

  const y2 = y ** 3;
  const x2 = x ** 3;
  const z2 = z ** 3;

  y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
  x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
  z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;

  x *= 0.95047;
  y *= 1;
  z *= 1.08883;

  return new XYZColor(x, y, z, alpha);
};

export default lab2xyz;
